import React, { Component } from "react";
import { connect } from "react-redux";
import { Dropdown, Menu } from "semantic-ui-react";
import PropTypes from "prop-types";
import { getUser, isAdmin, isLoggedIn } from "../../../../reducer";
import { Link } from "react-router-dom";
import { Translate } from "react-localize-redux";


class AdminLink extends Component {

    render() {

        if (this.props.admin) {
            if(this.props.mobile){
                return(
                    <Translate>
                        {({translate})=>
                            <Menu.Item>
                                <Menu.Header>{translate('general.admin')}</Menu.Header>
                                <Menu.Menu>
                                    <Menu.Item name={translate('admin.links.manage')} as={Link} to={'/admin/users'}/>
                                    <Menu.Item name={translate('admin.links.activities')} as={Link} to={'/admin/activities'}/>
                                    <Menu.Item name={translate("admin.links.reports")} as={Link}
                                               to={"/admin/reports"}/>
                                </Menu.Menu>
                            </Menu.Item>}
                    </Translate>

                );
            }
            return (
                <Translate>
                    {({translate})=>
                        <Dropdown item text={translate('general.admin')}>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link}  to={'/admin/users'}>{translate('admin.links.manage')}</Dropdown.Item>
                                <Dropdown.Item as={Link}  to={'/admin/activities'}>{translate('admin.links.activities')}</Dropdown.Item>
                                <Dropdown.Item as={Link}
                                               to={"/admin/reports"}>{translate("admin.links.reports")}</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>}
                </Translate>
            );
        }

        return null;
    }
}

AdminLink.contextTypes = {
    router: PropTypes.object
};


const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state),
    user: getUser(state),
    admin: isAdmin(state),
});



export default connect(
    mapStateToProps,
    null,
    null
)(AdminLink)



// WEBPACK FOOTER //
// ./src/components/Homepage/components/AdminLink/index.js